import React, {PropTypes} from 'react';
import moment from 'moment';
import classNames from 'classnames';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const FeeItem = ({
  id,
  fee,
  description,
  eventName,
  creationDate,
  inactiveDate,
  editing,
  onSwitchClick
}) => (
  <div
    className={classNames(
      'list-group-item-labeled hover-highlight',
      {'highlight animated flipInX': editing}
    )}
  >
    <div
      className="list-group-item-labeled-child"
      style={{width: 150}}
    >
      <span>{'Event'}</span>
      <span>{eventName}</span>
    </div>
    <div
      className="list-group-item-labeled-child"
      style={{width: 75}}
    >
      <span>{'Fee'}</span>
      <span>{`$${fee.formatCurrency(2)}`}</span>
    </div>
    <div
      className="list-group-item-labeled-child"
      style={{width: 200}}
    >
      <span>{'Description'}</span>
      <span>{description}</span>
    </div>
    <div
      className="list-group-item-labeled-child"
      style={{width: 150}}
    >
      <span>{'Creation Date'}</span>
      <span>
        {
          creationDate
          ? moment.parseZone(creationDate).format('MMM Do, YYYY')
          : '-'
        }
      </span>
    </div>
    {
      inactiveDate
      ? <div
          className="list-group-item-labeled-child"
          style={{width: 150}}
        >
          <span>{'Inactive Date'}</span>
          <span>{moment.parseZone(inactiveDate).format('MMM Do, YYYY')}</span>
        </div>
      : null
    }
    {
      id && !inactiveDate
      ? <div
          className="list-group-item-labeled-child"
          style={{width: 80}}
        >
          <button
            className="btn btn-link"
            style={{padding:0}}
            type="button"
            onClick={() => onSwitchClick({
              id,
              fee,
              description,
              eventName
            })}
          ><i
            className="fa fa-toggle-on"
            style={{fontSize: 36}}
          /></button>
        </div>
      : null
    }
  </div>
);

FeeItem.propTypes = {
  id: PropTypes.string,
  fee: PropTypes.number,
  description: PropTypes.string,
  eventName: PropTypes.string,
  creationDate: PropTypes.string,
  inactiveDate: PropTypes.string,
  editing: PropTypes.bool,
  onSwitchClick: PropTypes.func
};

FeeItem.defaultProps = {
  fee: 0
};

export default FeeItem;



// WEBPACK FOOTER //
// ./src/features/tournament/fees/FeeItem.jsx